import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const quickLinks = [
  { label: "Ice Cream's", path: '/ice-cream' },
  { label: 'Kwality Special', path: '/novelties?type=specials' },
  { label: 'Milkshakes', path: '/novelties?type=milkshakes' },
  { label: 'Falooda', path: '/novelties?type=falooda' },
  { label: 'Sundaes', path: '/novelties?type=sundaes' },
  { label: 'Kulfi', path: '/novelties?type=kulfi' },
  { label: 'Cassata', path: '/novelties?type=cassata' },
  { label: 'Coffee', path: '/novelties?type=coffee' },
  { label: 'Fresh Juice', path: '/novelties?type=fresh-juices' },
  { label: 'Ice Cream Cakes', path: '/novelties?type=ice-cream-cakes' },
  { label: 'Bombay Gola', path: '/novelties?type=bombay-gola' },
];

const locations = [
  '1060 North Main Street , Euless, Texas 76039, United States.',
  '13145 North Main Street, Frisco, Texas 75035, United States.',
  '8600 North Macarthur Boulevard, Irving, Texas 75063, United States.',
];

const Footer = () => (
  <footer className="footer">
    <div className="footer-main container-fluid p-0">
      {/* Left: Logo */}
      <div className="footer-logo-col">
        <img src={process.env.PUBLIC_URL + '/assets/footer-logo.png'} alt="Kwality Logo" className="footer-logo" />
      </div>
      {/* Middle: Quick Links */}
      <div className="footer-links-col">
        <div className="footer-links-title">Quick Links</div>
        <ul className="footer-quick-links">
          {quickLinks.map(link => (
            <li key={link.label}>
              <span className="footer-link-icon">
                <img src={process.env.PUBLIC_URL + '/assets/footercup.png'} alt="Link" />
              </span>
              <Link to={link.path}>{link.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      {/* Right: Locations, Contact, Social */}
      <div className="footer-info-col">
        <div className="footer-info-box">
          <div className="footer-info-section">
            <div className="footer-info-title">LOCATIONS</div>
            <ul className="footer-locations">
              {locations.map(loc => (
                <li key={loc}><span className="footer-loc-icon">📍</span> {loc}</li>
              ))}
            </ul>
          </div>
          <div className="footer-info-section">
            <div className="footer-info-title">CONTACT</div>
            <div className="footer-contact">+1 682-738-3010<br />dfwkwality@gmail.com</div>
          </div>
          <div className="footer-info-section">
            <div className="footer-info-title">FOLLOW US</div>
            <div className="footer-socials">
              <a href="https://instagram.com/yourprofile" className="footer-social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://facebook.com/yourprofile" className="footer-social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer; 